var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper bg-white"},[_c('b-container',[_c('div',{staticClass:"d-flex flex-column min-vh-100",attrs:{"id":"content"}},[_c('navBar'),_c('div',{staticClass:"flex-grow-1"},[_c('router-view')],1),_c('Footer')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }